import { render, staticRenderFns } from "./verifyAdvice.vue?vue&type=template&id=7bfb8d5a&scoped=true&"
import script from "./verifyAdvice.vue?vue&type=script&lang=js&"
export * from "./verifyAdvice.vue?vue&type=script&lang=js&"
import style0 from "./verifyAdvice.vue?vue&type=style&index=0&id=7bfb8d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb8d5a",
  null
  
)

export default component.exports